<progress class="c-progress c-progress--{{vm.variant}}" value="{{vm.value}}" max="{{vm.max}}">{{ vm.percent }}%</progress>
